import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=42b80c0b&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=42b80c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b80c0b",
  null
  
)

export default component.exports